import { debounce } from '@mui/material'
import clsx from 'clsx'
import { useCallback, useEffect, useState } from 'react'

import { UButton, UIcon } from '@src/components'

import styles from './styles.module.scss'

export const BackTopButton = () => {
  const [showButton, setShowButton] = useState(false)
  const show = () => {
    const after4scroll =
      window.innerHeight + window.pageYOffset >= window.innerHeight * 4
    if (after4scroll) {
      setShowButton(true)
    } else {
      setShowButton(false)
    }
  }

  const scrollToTop = useCallback(() => {
    window.scrollTo({
      behavior: 'smooth',
      top: 0,
    })
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', debounce(show, 300))
    // We want to run it only the first time, so the deps are empty.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return showButton ? (
    <div className={clsx(styles['back-to-top-button'], 'text-center')}>
      <UButton
        onClick={scrollToTop}
        startIcon={<UIcon name="arrow_upward" color="secondary" />}
      >
        ページの先頭へ
      </UButton>
    </div>
  ) : (
    <></>
  )
}
